// import {
//   Select,
//   SelectContent,
//   SelectGroup,
//   SelectItem,
//   SelectLabel,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";
// import { FileDown } from "lucide-react";
// import { z } from "zod";
// import { Form } from "@/components/ui/form";
// import { useForm } from "react-hook-form";
// import { zodResolver } from "@hookform/resolvers/zod";
// import { Input } from "@/components/ui/input";
// import TeaCoffeListTable from "./tea-coffe-list-table";
// import Paginat from "@/components/lib/paginat";
// import { Button } from "@/components/ui/button";
// import { Search } from "lucide-react";
// import { TabsContent } from "@/components/ui/tabs";
// import { useSelector } from "react-redux";

// function TeaCoffeeListTabs() {
//   const { teaCoffees } = useSelector((state) => state.menuManage.teaCoffee);
//   const form = useForm({
//     resolver: zodResolver(dateSchema),
//     defaultValues: {
//       date: "",
//     },
//   });

//   return (
//     <TabsContent value="drink">
//       <div className="mt-5">
//         <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
//           <div className="w-[260px]">
//             <Form {...form}>
//               <form>
//                 <div className="relative">
//                   <Search
//                     size={18}
//                     className="text-cwhite3 absolute top-2 left-2"
//                   />
//                   <Input placeholder="Search" className="bg-cblack3 pl-8" />
//                 </div>
//               </form>
//             </Form>
//           </div>
//           <div className="flex flex-col  gap-1.5 justify-end items-end">
//             <div className="flex gap-3 justify-center items-center">
//               <div className="relative">
//                 <Select>
//                   <SelectTrigger className="w-[100px]">
//                     <SelectValue placeholder="Status" />
//                   </SelectTrigger>
//                   <SelectContent>
//                     <SelectGroup>
//                       <SelectItem value="20">Active</SelectItem>
//                       <SelectItem value="50">Archived</SelectItem>
//                     </SelectGroup>
//                   </SelectContent>
//                 </Select>
//               </div>
//               <Button
//                 className={"bg-cblack3 border border-gray-600 text-cwhite2"}
//               >
//                 <FileDown size={18} /> Export
//               </Button>
//               <div className="flex gap-1 justify-center items-center">
//                 <h3 className="text-white">Show</h3>
//                 <Select>
//                   <SelectTrigger className="w-[60px]">
//                     <SelectValue placeholder="10" />
//                   </SelectTrigger>
//                   <SelectContent>
//                     <SelectGroup>
//                       <SelectItem value="20">20</SelectItem>
//                       <SelectItem value="50">50</SelectItem>
//                     </SelectGroup>
//                   </SelectContent>
//                 </Select>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="mt-5">
//           <TeaCoffeListTable teaCoffees={teaCoffees} />
//         </div>
//         <div>
//           <Paginat />
//         </div>
//       </div>
//     </TabsContent>
//   );
// }

// export default TeaCoffeeListTabs;

// const dateSchema = z.object({
//   date: z.string().min(1, "Date is required"),
// });

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FileDown } from "lucide-react";
import { z } from "zod";
import { useState } from "react";
import { Form } from "@/components/ui/form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Input } from "@/components/ui/input";
import TeaCoffeListTable from "./tea-coffe-list-table";
import Paginat from "@/components/lib/paginat";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { useSelector } from "react-redux";
import { useFilter } from "@/hooks/useFilter";
import { useSearch } from "@/hooks/useSearch";
import { usePagination } from "@/hooks/usePagination";

function TeaCoffeeListTabs() {
  const { teaCoffees } = useSelector((state) => state.menuManage.teaCoffee);

  const [filters, setFilters] = useState({
    status: "",
  });
  const [searchText, setSearchText] = useState("");
  const [perPage, setPerPage] = useState(10);
  const filteredData = useFilter(teaCoffees, filters, {
    delay: 300,
    defaultFilter: (item) =>
      item.status !== "draft" &&
      (filters.status === "archived" ? item.status === "archived" : item.status !== "archived"),
  });

  const searchData = useSearch(
    filteredData,
    searchText,
    ["item_no", "name", "description"],
    300
  );
  const { paginatedData, paginationInfo, onPageChange } = usePagination(
    searchData,
    perPage
  );

  return (
    <TabsContent value="drink">
      <div className="mt-5">
        <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
          <div className="w-[260px]">
            <div className="relative">
              <Search
                size={18}
                className="text-cwhite3 absolute top-2 left-2"
              />
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search"
                className="bg-cblack3 pl-8"
              />
            </div>
          </div>
          <div className="flex flex-col  gap-1.5 justify-end items-end">
            <div className="flex gap-3 justify-center items-center">
              <div className="relative">
                <Select
                  onValueChange={(value) =>
                    setFilters((prev) => ({
                      ...prev,
                      status: value === "0" ? "" : value,
                    }))
                  }
                >
                  <SelectTrigger className="w-[100px]">
                    <SelectValue placeholder="Status" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="0">All</SelectItem>
                    <SelectItem value="active">Active</SelectItem>
                    <SelectItem value="inactive">Inactive</SelectItem>
                    <SelectItem value="archived">Archived</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <Button
                className={"bg-cblack3 border border-gray-600 text-cwhite2"}
              >
                <FileDown size={18} /> Export
              </Button>
              <div className="flex gap-1 justify-center items-center">
                <h3 className="text-white">Show</h3>
                <Select
                  onValueChange={(value) => setPerPage(Number(value))}
                  value={perPage.toString()}
                >
                  <SelectTrigger className="w-[60px]">
                    <SelectValue placeholder="10" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="10">10</SelectItem>
                      <SelectItem value="20">20</SelectItem>
                      <SelectItem value="40">40</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <TeaCoffeListTable teaCoffees={paginatedData} />
        </div>
        <div>
          <Paginat
            pagination={paginationInfo}
            onPageChange={onPageChange}
            className="mt-4"
          />
        </div>
      </div>
    </TabsContent>
  );
}

export default TeaCoffeeListTabs;

const dateSchema = z.object({
  date: z.string().min(1, "Date is required"),
});
